// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__kSXpT","gfeWrapper":"CalendarEvent_gfeWrapper__2Y_0C"};